import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { apigQuery } from '../api/apigQuery';
import { gqlQuery } from '../api/gqlQuery';
import { aioQuery } from '../api/k8sQuery';

import callTranscriptionReducer from './store/callTranscriptionSlice';
import { eventReducer } from './store/eventSlice';
import largeTableReducer from './store/largeTableSlice';
import { loginReducer } from './store/loginSlice';
import onboardingReducer from './store/onboardingSlice';
import { recoilUserSyncReducer } from './store/recoilSyncSlice';
import superAdminStatsReducer from './store/superAdminStatsSlice';
import { themeReducer } from './store/themeSlice';
import { userReducer } from './store/userSlice';

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false,
});
const persistConfig = {
  key: 'root',
  storage,
  blacklist: [gqlQuery.reducerPath],
};

export const store = configureStore({
  reducer: {
    onboarding: persistReducer(persistConfig, onboardingReducer),
    superAdminStats: superAdminStatsReducer,
    callTranscription: callTranscriptionReducer,
    largeTable: largeTableReducer,
    user: userReducer,
    theme: themeReducer,
    recoilUserSync: recoilUserSyncReducer,
    event: eventReducer,
    login: loginReducer,
    [gqlQuery.reducerPath]: gqlQuery.reducer,
    [apigQuery.reducerPath]: apigQuery.reducer,
    [aioQuery.reducerPath]: aioQuery.reducer,
  },
  middleware: customizedMiddleware.concat(
    gqlQuery.middleware,
    apigQuery.middleware,
    aioQuery.middleware
  ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
